<template>
    <div :class="['blurCapImage', orientation]">
        <div class="contentWrapper">
            <div class="content">
                <div class="cover blurredCover loadEffect"></div>
                <div class="slot">
                    <div class="text">
                        <div class="skeletonHeading loadEffect skeletonLonger skeletonSpacingSmall"></div>
                        <div class="skeletonSubtitle loadEffect skeletonShort skeletonSpacingLarge"></div>
                        <div class="skeletonSubtitle loadEffect skeletonLonger skeletonSpacingLarge"></div>
                    </div>
                    <div class="text">
                        <div class="skeletonDescription loadEffect skeletonFull skeletonSpacingSmall"></div>
                        <div class="skeletonDescription loadEffect skeletonFull skeletonSpacingSmall"></div>
                        <div class="skeletonDescription loadEffect skeletonFull skeletonSpacingSmall"></div>
                        <div class="skeletonDescription loadEffect skeletonShorter skeletonSpacingMedium"></div>
                    </div>
                </div>
            </div>
            <div class="coverWrapper">
                <div class="cover loadEffect"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
       name: 'BlurCapImageSkeleton',
       props: {
            orientation: {
                type: String,
                default: 'landscape',
                validator: type => ['landscape','portrait'].includes(type)
            }
       }
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .blurCapImage {
        min-height: 28rem;
        border-radius: 1rem;
        transition: $transition-eio-20;
        position: relative;
        overflow: hidden;

        &:hover {
            transform: translateY(-0.5rem) scale(1.01);

            .contentWrapper {
                box-shadow: var(--shadow-xl);
            }
        }
    }

    .contentWrapper {
        display: flex;
        justify-content: flex-end;
        position: relative;
        height: 100%;
        border-radius: 1rem;
        box-shadow: var(--shadow-l);
        overflow: hidden;
        transition: $transition-eio-20;
        border-radius: 0.75rem;
    }

    .content {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        z-index: 1;
        overflow: hidden;
    }

    .landscape {
        .content {
            max-width: 24rem;
            min-height: 28rem;
            height: 100%;
        }

        .contentWrapper {
            min-height: 28rem;
        }
    }

    .portrait {
        height: auto;

        .content {
            width: 100%;
            margin-top: 28rem;
        }

        .blurredCover {
            bottom: 20rem;
            left: 0;
        }
    }

    .slot {
        position: relative;
        background: var(--color-white-40);
        height: 100%;
        padding: 2rem;
    }

    .coverWrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }

    .cover {
        display: block;
        width: 100%;
        height: 100%;
        background: var(--color-grey-150);
    }

    .blurredCover {
        position: absolute;
    }

    @media all and (max-width: 1200px) {
        .landscape {
            .content {
                max-width: 18rem;
            }
        }
    }

    @media all and (max-width: 560px) {
        .landscape {
            height: auto;

            .content {
                width: 100%;
                margin-top: 20rem;
                max-width: 100%;
            }
        }
    }
</style>